import { useTranslation } from "react-i18next";
import Widget from "../Widget";
import HistoryLine from "./HistoryLine";
import useHistoryWidget from "./useHistoryWidget";
import useIsMobile from "../../../hooks/useIsMobile";
import styles from "./historyWidget.module.css";

const HistoryWidget = () => {
  const { t } = useTranslation();
  const { isLoading, historyItems } = useHistoryWidget();
  const isMobile = useIsMobile();

  if (isMobile === true) return null;

  return (
    <Widget header={t("nav.history")} isLoading={isLoading} centered>
      <div className={styles.historyWidget}>
        {historyItems.map((item) => (
          <HistoryLine key={item?.id} {...item} />
        ))}
      </div>
    </Widget>
  );
};

export default HistoryWidget;
